<template>
  <div v-if="!isDetails">
    <div v-if="payFlag" class="global-loading">
      <div class="loading-spinner"></div>
      <div class="loading-text">正在支付中，请稍等...</div>
    </div>
    <block v-if="orderInfo && orderInfo.finish == 1">
      <div class="sucess-header">
        <div class="sucess-header__status">
          <img src="https://staticcdn.pospal.cn//we/mini/image/icons_v2/success-icon.png" />
          支付成功
        </div>
        <svg id="barcode" v-if="orderInfo.extData.orderNo"></svg>
        <div v-if="orderInfo.daySeq" class="pickup-code">
          {{ orderInfo.daySeq }}
        </div>
        <!-- <div v-if="!orderInfo.ticketSn && orderInfo.daySeq" class="pickup-loading">
          <div class="weui-loading"></div>
        </div> -->
        <div class="cut-off"></div>
        <div class="pay-info">
          <div class="pay-info__cell">
            <span>支付金额:</span>
            <span style="font-weight: 600;">￥{{ orderInfo.amount || 0 }}</span>
          </div>
          <div class="pay-info__cell">
            <span>店铺名称:</span>
            <span v-html="orderInfo.storeName"></span>
          </div>
          <div class="pay-info__cell">
            <span>单据编号:</span>
            <span>{{ orderInfo.extData.orderNo }}</span>
          </div>
          <div class="pay-info__cell" v-if="orderInfo.customerName">
            <span>本次积分:</span>
            <span>{{ orderInfo.gaintPoint || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="user-info" v-if="orderInfo.customerName">
        <div class="user">
          <img
            :src="customerPhoto ? customerPhoto : 'https://staticcdn.pospal.cn/we/mini/image/icons/default_header_v2.png'" />
          {{ orderInfo.customerName }}
        </div>
        <div class="user-content">
          会员等级: {{ orderInfo.customerCategoryName }}
        </div>
        <div class="user-content">
          会员积分: {{ orderInfo.customerPoint || 0 }}
        </div>
      </div>
    </block>
    <block v-else>
      <block v-if="YB_ERRORCODE">
        <div class="error">
          <div class="error-header">
            <img src="https://staticcdn.pospal.cn//we/mini/image/icons_v2/warn-icon.png" />
            扫码失败
          </div>
          <div class="cut-off"></div>
          <div class="message" v-if="YB_ERRORCODE == 200">
            请用<span> 微信 </span>或<span> 支付宝 </span>扫码 <img
              src="https://staticcdn.pospal.cn//we/mini/image/icons_v2/aliPay-icon.png" /><img
              src="https://staticcdn.pospal.cn//we/mini/image/icons_v2/weChart-icon.png" />
          </div>
          <div class="message" v-else>
            {{ getMessage(YB_ERRORCODE) }}
          </div>
        </div>
      </block>
      <block v-if="!YB_ERRORCODE || YB_ERRORCODE == ''">
        <div class="header">
          <div class="header__left">
            <p>付款给</p>
            <!-- 店铺名来自 LoadStoreInfo：CodeExtConfig.collectionCodeName 或 StoreName，为空时多为该号接口未返回 -->
            <p v-html="YB_StoreName || '门店'"></p>
          </div>
          <img class="header__right" :src="YB_StoreLogo" />
        </div>
        <div class="pay-panel">
          <div class="pay-panel__title">
            付款金额
          </div>
          <div class="pay-panel__input" @click.stop="openVirtualKeyboard()">
            <div class="content">
              ￥
              <div v-for="(item, index) in content" @click="getStrPosition(index + 1)">
                <div class="number-block">
                  {{ item }}
                  <!-- 光标 -->
                  <div class="cursor cursor-insert" v-if="cursorIndex === index + 1"></div>
                </div>
              </div>
              <div class="cursor cursor-insert" style="left: 34px;" v-if="!cursorIndex || cursorIndex == 0"></div>
              <div class="pay-panel_notes" v-if="CodeExtConfig && CodeExtConfig.enableTicketRemark" @click="openNotes">
                添加备注</div>
            </div>
          </div>
          <div class="preferential_info"
            v-if="balance != null && CodeExtConfig && CodeExtConfig.supportCoupon !== false">
            <div class="preferential_info__option" v-if="autoPreferential"
              @click="autoPreferential = false; getPreferentialCost()">
              <img src="//staticcdn.pospal.cn/we/mini/image/icons_v2/circular_selected.png" />
              <span>自动使用优惠券</span>
              <span v-if="money">实付:￥{{ paidInAmount }}</span>
              <span v-else>实付:￥0.00</span>
            </div>
            <div class="preferential_info__option" v-else @click="autoPreferential = true; getPreferentialCost()">
              <img src="//staticcdn.pospal.cn/we/mini/image/icons_v2/circular_unselect.png" />
              <span>自动使用优惠券</span>
              <span>实付:￥{{ (payMethod == 'balance' && categoryDiscount) ? (money * categoryDiscount / 100).toFixed(2) :
                (money ? money : '0.00') }}</span>
            </div>
            <div class="preferential_info__coupon" v-if="autoPreferential && preferentialInfo && money != ''">
              <div>券</div>
              <span>{{ preferentialInfo.discountName }}</span>
              <span v-if="DiscountAmount">￥-{{ DiscountAmount }}</span>
              <span v-else></span>
            </div>
          </div>
          <div class="payment_method">
            <div class="payment_method__header">选择支付方式</div>
            <div class="method" @click="() => changePaymethod('unionpay')" v-if="supportUnionPay">
              <div class="method__main">
                <img src="//staticcdn.pospal.cn/we/westroe/img/payments/yinlian_pay2@2x.png" />
                <div class="method__content">
                  <span class="method__name">云闪付支付</span>
                  <span class="cost-off unionpay-promotion" v-if="unionPayPromotionText">{{ unionPayPromotionText }}</span>
                </div>
              </div>
              <div v-if="!isUnionPaySelected" class="unselected"></div>
              <div v-else class="select">
                <img src="//staticcdn.pospal.cn//we/mini/image/icons_v2/paypage_selected.png" />
              </div>
            </div>
            <div class="method-cut-off" v-if="supportUnionPay"></div>
            <div class="method" @click="() => changePaymethod('wechat')">
              <div class="method__main">
                <img :src="getPayMode.img" />
                <span class="method__name">{{ getPayMode.name }}支付</span>
              </div>
              <div v-if="!isWechatSelected" class="unselected"></div>
              <div v-else class="select">
                <img src="//staticcdn.pospal.cn//we/mini/image/icons_v2/paypage_selected.png" />
              </div>
            </div>
            <div class="method-cut-off" v-if="balance != null && CodeExtConfig && CodeExtConfig.supportBalance !== false"></div>
            <div class="method" @click="() => changePaymethod('balance')"
              v-if="balance != null && CodeExtConfig && CodeExtConfig.supportBalance !== false">
              <div class="method__main">
                <img src="//staticcdn.pospal.cn//we/mini/image/icons_v2/balance_pay_icon.png" />
                <span class="method__name">余额支付</span><span class="blance">(余额￥{{ balance }})</span> <span class="cost-off"
                  v-if="isBalanceSelected && money > 0 && discountAnalyses && foldUp">可减￥{{
                    discountAnalyses.DiscountAmount
                  }}元</span>
              </div>
              <div v-if="!isBalanceSelected" class="unselected"></div>
              <div v-else class="select">
                <img src="//staticcdn.pospal.cn//we/mini/image/icons_v2/paypage_selected.png" />
              </div>
            </div>
        <div class="recharge" v-if="showRechargeRule">
          <span>{{ getChargeDesc ? getChargeDesc : '' }}</span>
          <div @click="() => toCharge()">去充值</div>
        </div>
  </div>
  <button v-if="money && money != '0.' && money != '0' && money != '0.0'" class="confirm_payment"
    @click.stop="handlePayClick">
    确认支付
  </button>
  <div v-else class="confirm_payment pay-btn-display">
    确认支付
  </div>
  </div>
  </block>
  </block>
  <div v-if="!balance && !YB_ERRORCODE && !orderNo && showLogin && !isLogin" :class="getClass" @click="toCenter">
    <div>
      <img src="//staticcdn.pospal.cn//we/mini/image/icons_v2/paypage_gift.png" />
      {{ loginTip ? loginTip : '登录可使用会员余额支付并获得奖励' }}
    </div>
    <div>
      <span>去登录 ></span>
    </div>
  </div>
  <div v-if="(!((orderInfo && orderInfo.finish == 1))) && !YB_ERRORCODE && showKeyBorad"
    v-clickoutside="handleClickOutside" class="keyboard" id="virtual-keyboard">
    <div class="key-box">
      <div class="number-box clearfix">
        <button v-for="(item, index) in KeyboardKeys" class="key" :class="index === 9 ? 'key-zero' : ''"
          hover-class="number-box-hover" @click="keyTap(item)">
          {{ item }}
        </button>
      </div>
      <div class="btn-box">
        <button class="key delete-btn" hover-class="number-box-hover" data-keys="<" @click="keyTap('<')">
          <div class="delete-icon">
            <div class="delete-cross"></div>
          </div>
        </button>
        <block>
          <button v-if="money && money != '0.' && money != '0' && money != '0.0'" class="key pay_btn"
            @click.stop="handlePayClick">
            确认<br />支付
          </button>
          <div v-else class="key pay_btn pay-btn-display">
            确认<br />支付
          </div>
        </block>
      </div>
    </div>

  </div>

  <div class="notes-modal" v-if="showNotesModal">

    <div class="notes-modal__content">
      <div class="notes-modal__content__title">请输入备注</div>
      <textarea class="notes-modal__content__textarea" v-model="notes"></textarea>
      <div class="notes-modal__footer">
        <button class="notes-modal__footer__button notes-modal__footer__button--cancel"
          @click="closeNotesModal">取消</button>
        <button class="notes-modal__footer__button notes-modal__footer__button--save" @click="saveNotes">保存</button>
      </div>
    </div>

  </div>
  </div>

</template>



<script>
// const vConsole = new window.VConsole();
import axios from "axios";
import JsBarcode from "jsbarcode";

function loadScript(url, callback) {
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.src = url;

  script.onload = function () {
    callback();
  };

  document.head.appendChild(script);
}

// reserve.js用来放一些鬼知道要注入的什么js方法，目前没用到，只放了vconsole的代码，解放下面的注释就能使用vconsole调试。
// // 加载指定的JavaScript文件
// loadScript('https://staticcdn.pospal.cn/payPage/reserve.js', function () {
//   // 执行您的JavaScript代码
//   var vConsole = new window.VConsole();
// });

console.log("开始加载js", new Date().getTime());

// 支付回调需要实现的方法，不用管，现在用银豹付貌似不会用到这里的代码了
window.PospalModal = function () {
  var app = this;
  app.showIndicator = function () { };
  app.hideIndicator = function () { };
};

/**
 * 防抖方法
 * @param func
 * @param delay
 */
function debounce(func, delay) {
  let timeoutId;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
}

/**
 * @description: 判断是微信支付宝还是云闪付
 * @return {*}
 */
function getPayMode() {
  // /AlipayClient/.test(window.navigator.userAgent),
  const modeList = [
    {
      name: "微信",
      reg: /MicroMessenger/,
      img: "//staticcdn.pospal.cn//we/mini/image/icons_v2/wx_pay_icon.png"
    },
    {
      name: "支付宝",
      reg: /AlipayClient/,
      img: "//staticcdn.pospal.cn//we/mini/image/icons_v2/paypage_alipay_icon.png"
    },
    {
      name: "云闪付",
      reg: /UnionPay/,
      img: "//staticcdn.pospal.cn/we/westroe/img/payments/yinlian_pay2@2x.png"
    }
  ];
  for (let i = 0; i < modeList.length; i++) {
    if (modeList[i].reg.test(window.navigator.userAgent)) {
      return modeList[i];
    }
  }
  // 如果没有匹配到任何支付方式，返回默认值
  return {
    name: "微信",
    reg: /MicroMessenger/,
    img: "//staticcdn.pospal.cn//we/mini/image/icons_v2/wx_pay_icon.png"
  };
}

/**
 * 从url取参的方法，传入key，会返回value
 * @param variable
 */
function getQueryVariable(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
}
export default {
  name: "App",
  directives: {
    clickoutside: {
      bind: function (el, binding, vnode) {
        // 点击外部区域时触发的事件处理函数
        el.clickOutsideEvent = function (event) {
          // 检查点击的元素是否在el之外
          if (!(el == event.target || el.contains(event.target))) {
            // 调用在v-click-outside指令中指定的方法
            vnode.context[binding.expression](event);
          }
        };
        // 在整个文档上添加点击事件监听器
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function (el) {
        // 移除点击事件监听器
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  },
  computed: {
    getClass() {
      return !(this.orderInfo && this.orderInfo.finish == 1) &&
        this.showKeyBorad
        ? "login"
        : "login to-bottom";
    },
    getChargeDesc() {
      if (this.chargeRules && this.chargeRules.length > 0) {
        return this.chargeRules
          .map(a => {
            // 如果GiftDesc存在且有值，显示"立赠"，否则不显示
            if (a.GiftDesc && a.GiftDesc.trim()) {
              return `充￥${a.ChargeAmount}立赠${a.GiftDesc}`;
            } else {
              return `充￥${a.ChargeAmount}`;
            }
          })
          .join(";");
      } else {
        return "";
      }
    },
    // 获取实际需要支付的金额（考虑优惠券后的实付金额）
    actualPayAmount() {
      // 如果使用了优惠券，使用优惠后的实付金额；否则使用原始输入金额
      if (this.autoPreferential && this.preferentialInfo && this.paidInAmount > 0) {
        return parseFloat(this.paidInAmount) || 0;
      }
      return parseFloat(this.money) || 0;
    },
    supportUnionPay() {
      return this.CodeExtConfig && this.CodeExtConfig.supportUnionPay === true;
    },
    unionPayMethodCode() {
      return this.CodeExtConfig && this.CodeExtConfig.unionPayMethodCode
        ? this.CodeExtConfig.unionPayMethodCode
        : -2917;
    },
    unionPayPromotionText() {
      return this.CodeExtConfig && this.CodeExtConfig.unionPayPromotionText
        ? this.CodeExtConfig.unionPayPromotionText
        : "";
    },
    isUnionPaySelected() {
      return this.payMethod == 'unionpay';
    },
    isWechatSelected() {
      return this.payMethod == 'wechat';
    },
    isBalanceSelected() {
      // 余额充足时，不允许组合支付，直接按支付方式判断
      // 使用实际需要支付的金额（考虑优惠券）来判断
      if (this.balance != null && this.actualPayAmount > 0 && parseFloat(this.balance) >= this.actualPayAmount) {
        return this.payMethod == 'balance';
      }
      // 如果启用了组合支付且选择了组合支付，且实际支付金额大于余额，则余额支付选中
      if (this.balanceCombinationPayment == 1 && this.selectedCombinationPayment && this.balance != null && this.actualPayAmount > 0 && parseFloat(this.balance) < this.actualPayAmount) {
        return true;
      }
      // 否则按原来的逻辑
      return this.payMethod == 'balance';
    }
  },
  data() {
    return {
      showNotesModal: false, // 备注弹窗是否展示
      notes: '', //备注 备用 真正的备注字段在collectioncodeticket.remark;
      remark: '', // 真正的备注字段
      getPayMode: getPayMode(),
      showKeyBorad: true, // 虚拟键盘是否展示（目前是默认展示）
      YB_ERRORCODE: undefined, // 1未支付，2支付成功，3支付失败 YB开头的变量都是后端通过cshtml注入进来的全局变量（具体可以试一下，现在貌似不用这种方式传值，改用常规的接口获取了，接口是LoadStoreInfo）
      YB_ORDERNO: undefined,
      KeyboardKeys: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "."],
      collectionCodeUid: undefined,
      isDetails: false, // 为true则说明是已经支付过的页面，回调回来要展示支付后的详情页
      isAli: /AlipayClient/.test(window.navigator.userAgent),
      orderNo: "",
      unionPayReturnQuerying: false,
      unionPayPageHidden: false,
      payMethod: "wechat", //目前只有两种支付方式，wechat跟balance，支付宝支付也是wechat
      payFlag: false, //防抖，为true的时候不运行
      cursorIndex: 0, // 付款金额的光标
      showLogin: false, // 是否展示会员登录
      categoryDiscount: null, //会员折扣
      foldUp: false, // 是否展示会员折扣
      categoryDiscountType: null, //折扣类型
      DiscountAmount: null, // 折扣金额
      preferentialInfo: null, // 优惠信息
      autoPreferential: true, //表示是否自动应用可用的优惠（如优惠券或会员折扣）。如果为 true，则系统在结算时自动选择最佳或可用的优惠方案。
      YB_StoreName: undefined,
      YB_StoreLogo: undefined,
      money: "",
      paidInAmount: 0, // 实付价格
      content: [], // 暂存虚拟键盘的 输入
      orderFlag: false, // orderFlag如果为true需要获取新的订单号
      orderInfo: null, // 订单信息
      balance: null, // 余额
      unionPayPendingToken: "",
      unionPayReturnTimer: null,
      isLogin: false, // 会员是否已登录
      loginTip: "", // 登录提示
      totalAmount: null, // 支付的总金额
      pressStartTime: null, // 长按，虚拟键盘用的
      pressEndTime: null, // 同上
      isPressing: false, // 同上
      discountAnalyses: null, // 具体启用的优惠信息
      chargeRules: null, // 充值规则
      showRechargeRule: false, // 是否展示充值规则
      CodeExtConfig: null, //付款码扩展配置信息（可空），包含属性supportBalance：付款码是否支持余额支付（可空，值为false时才不支持）、supportCoupon：付款码是否支持会员优惠券（可空，值为false时才不支持）、supportShoppingCard：付款码是否支持购物卡（可空，值为false时才不支持）、withAddTicket：付款码是否需要生成单据（可空，0-否，1/NULL-是）
      balanceCombinationPayment: 0, //余额组合支付，0-否，1-是
      // 选中了组合支付
      selectedCombinationPayment: false
    };
  },
  // loop(func, num = 0) {
  //   let time = 2000;
  //   if (num < 2 && !this.orderInfo) {
  //     setTimeout(() => {
  //       num++;
  //       func();
  //     }, time);
  //   }
  // },
  mounted() {

    // 判断是不是支付宝
    this.unionPayReturnQuerying = false;
    this.unionPayPageHidden = this.isUnionPayPendingTokenMatched();
    const payMode = getPayMode();
    console.log("🚀 ~ mounted ~ payMode:", payMode, payMode && payMode.name === "支付宝")
    if (payMode && payMode.name === "支付宝") {
      // 支付宝
      // console.log("支付宝");
      if (window.AlipayJSBridge) {
        this.initPage();
      } else {
        document.addEventListener("AlipayJSBridgeReady", this.initPage, false);
      }
    } else {
      // 微信或其他
      console.log("微信");
      this.initPage();
    }
    window.addEventListener("pageshow", this.handleUnionPayPageShow);
    window.addEventListener("focus", this.handleUnionPayPageFocus);
    document.addEventListener("visibilitychange", this.handleUnionPayVisibilityChange);
    this.handleUnionPayPageShow();
    this.startUnionPayReturnPolling();
  },
  beforeDestroy() {
    document.removeEventListener("AlipayJSBridgeReady", this.initPage);
    window.removeEventListener("pageshow", this.handleUnionPayPageShow);
    window.removeEventListener("focus", this.handleUnionPayPageFocus);
    document.removeEventListener("visibilitychange", this.handleUnionPayVisibilityChange);
    this.stopUnionPayReturnPolling();
  },
  watch: {
    orderInfo: function (val) {
      if (val && val.extData) {
        this.$nextTick(() => {
          JsBarcode("#barcode", val.extData.orderNo, {
            displayValue: false,
            lineColor: "#000",
            background: "rgba(0,0,0,0)",
            width: 5
          });
        });
      }
    },
    money: function (newMoney) {
      // 当金额变化时，仅在余额不足时设置默认支付方式
      // 余额充足时，不自动切换，允许用户自由选择支付方式
      if (this.balanceCombinationPayment == 1 && this.balance > 0 && newMoney > 0) {
        if (this.balance < newMoney) {
          // 输入金额大于余额，默认选中当前优先级最高的线上支付方式
          this.payMethod = this.getDefaultOnlinePayMethod();
          this.selectedCombinationPayment = false;
        }
        // 余额充足时，不自动切换支付方式，保持用户的选择
      }
    }
  },
  methods: {
    closeNotesModal() {
      this.notes = '';
      this.showNotesModal = false;
    },
    saveNotes() {
      this.remark = this.notes;
      // this.notes = '';
      this.showNotesModal = false;

    },
    openNotes() {
      console.log("🚀 ~ openNotes ~ openNotes:")
      this.showNotesModal = true;
    },
    getDefaultOnlinePayMethod() {
      return 'wechat';
    },
    isOnlinePayMethod(type) {
      return type === 'wechat' || type === 'unionpay';
    },
    appendOnlinePayParams(param) {
      param.payMethod = "0";
      if (this.payMethod == "unionpay") {
        param.payMethodCode = this.unionPayMethodCode;
      } else if (param.payMethodCode) {
        delete param.payMethodCode;
      }
    },
    executePayScript(script) {
      if (!script) {
        return;
      }
      const scriptText = (script + "").replace(/^\s+|\s+$/g, "");
      const locationMatch = scriptText.match(/^(?:top\.)?location(?:\.href)?\s*=\s*['"]([^'"]+)['"]\s*;?$/i);
      if (/^https?:\/\//i.test(scriptText)) {
        window.location.href = scriptText;
        return;
      }
      if (locationMatch && /^https?:\/\//i.test(locationMatch[1])) {
        window.location.href = locationMatch[1];
        return;
      }
      try {
        eval(script);
      } catch (error) {
        console.log("脚本运行错误-", error);
      }
    },
    getUnionPayPendingToken() {
      if (window.history && window.history.state && window.history.state.pendingPayToken) {
        return window.history.state.pendingPayToken;
      }
      return this.unionPayPendingToken || "";
    },
    isUnionPayPendingTokenMatched() {
      const pendingPayToken = localStorage.getItem("pendingPayToken");
      return !!pendingPayToken && pendingPayToken === this.getUnionPayPendingToken();
    },
    setUnionPayPendingToken(token) {
      this.unionPayPendingToken = token;
      localStorage.setItem("pendingPayToken", token);
      if (window.history && window.history.replaceState) {
        const state = Object.assign({}, window.history.state || {}, { pendingPayToken: token });
        window.history.replaceState(state, document.title, location.href);
      }
    },
    clearUnionPayPendingToken() {
      this.unionPayPendingToken = "";
      localStorage.removeItem("pendingPayToken");
      if (window.history && window.history.replaceState) {
        const state = Object.assign({}, window.history.state || {});
        delete state.pendingPayToken;
        window.history.replaceState(state, document.title, location.href);
      }
    },
    handleUnionPayPageShow() {
      if (this.isUnionPayPendingTokenMatched() && this.unionPayPageHidden) {
        this.checkUnionPayPaymentOnReturn();
      }
      this.startUnionPayReturnPolling();
    },
    handleUnionPayPageFocus() {
      if (this.isUnionPayPendingTokenMatched() && localStorage.getItem("pendingPayMethod") === "unionpay") {
        this.checkUnionPayPaymentOnReturn();
      }
      this.startUnionPayReturnPolling();
    },
    handleUnionPayVisibilityChange() {
      if (document.visibilityState === "hidden" && this.isUnionPayPendingTokenMatched() && localStorage.getItem("pendingPayMethod") === "unionpay") {
        this.unionPayPageHidden = true;
        return;
      }
      if (document.visibilityState === "visible") {
        if (this.isUnionPayPendingTokenMatched() && this.unionPayPageHidden) {
          this.checkUnionPayPaymentOnReturn();
        }
        this.startUnionPayReturnPolling();
      }
    },
    startUnionPayReturnPolling() {
      if (
        this.unionPayReturnTimer ||
        localStorage.getItem("pendingPayMethod") !== "unionpay" ||
        !this.isUnionPayPendingTokenMatched()
      ) {
        return;
      }

      this.unionPayReturnTimer = setInterval(() => {
        const pendingPayTime = parseInt(localStorage.getItem("pendingPayTime"), 10) || 0;
        if (
          localStorage.getItem("pendingPayMethod") !== "unionpay" ||
          !this.isUnionPayPendingTokenMatched()
        ) {
          this.stopUnionPayReturnPolling();
          return;
        }
        if (Date.now() - pendingPayTime > 2 * 60 * 1000) {
          this.clearUnionPayPendingPayment();
          return;
        }
        this.checkUnionPayPaymentOnReturn();
      }, 3000);
    },
    stopUnionPayReturnPolling() {
      if (this.unionPayReturnTimer) {
        clearInterval(this.unionPayReturnTimer);
        this.unionPayReturnTimer = null;
      }
    },
    clearUnionPayPendingPayment() {
      localStorage.removeItem("fromPayment");
      localStorage.removeItem("orderNo");
      localStorage.removeItem("pendingPayMethod");
      localStorage.removeItem("pendingPayTime");
      this.clearUnionPayPendingToken();
      this.unionPayPageHidden = false;
      this.stopUnionPayReturnPolling();
    },
    checkUnionPayPaymentOnReturn() {
      const orderNo = localStorage.getItem("orderNo");
      const pendingPayTime = parseInt(localStorage.getItem("pendingPayTime"), 10) || 0;
      if (
        this.unionPayReturnQuerying ||
        /\/details\//.test(location.href) ||
        /op=cancel/.test(location.href) ||
        localStorage.getItem("pendingPayMethod") !== "unionpay" ||
        !this.isUnionPayPendingTokenMatched() ||
        !localStorage.getItem("fromPayment") ||
        !orderNo
      ) {
        return;
      }
      if (Date.now() - pendingPayTime > 2 * 60 * 1000) {
        this.clearUnionPayPendingPayment();
        return;
      }

      this.unionPayReturnQuerying = true;
      axios
        .post("/wxapi/pospalh5pay/Details", {
          orderNo: orderNo,
          incCustomer: true
        })
        .then(res => {
          const result = res.data && res.data.result;
          if (res.data && res.data.successed && result && result.finish == 1) {
            this.orderNo = orderNo;
            this.orderInfo = result;
            this.clearUnionPayPendingPayment();
          }
          this.unionPayReturnQuerying = false;
        })
        .catch(err => {
          console.log("query unionpay payment on return error", err);
          this.unionPayReturnQuerying = false;
        });
    },
    initPage() {
      const that = this;
      document.body.style.height = document.body.clientHeight + "px";
      const payMode = getPayMode();

      // 优化判断逻辑
      const isDetailsPage = /\/details\//.test(location.href);
      const hasOrderNo = localStorage.getItem("orderNo");
      const isFromPayment = localStorage.getItem("fromPayment");
      console.log("🚀 ~ initPage ~ isDetailsPage:", isDetailsPage, hasOrderNo, isFromPayment)

      if (!isDetailsPage && hasOrderNo && isFromPayment && payMode && payMode.name === "支付宝") {
        // 清除支付相关的存储
        localStorage.removeItem("orderNo");
        localStorage.removeItem("fromPayment");
        localStorage.removeItem("collectionCodeUid");
        localStorage.removeItem("pendingPayMethod");
        localStorage.removeItem("pendingPayTime");
        this.clearUnionPayPendingToken();

        // 仅在支付宝环境下调用关闭
        if (/AlipayClient/.test(window.navigator.userAgent)) {
          console.log("支付完成，关闭页面");
          AlipayJSBridge.call("popWindow");
          return;
        }
        return;
      }

      let param = {};
      if (this.getQueryVariable("uid")) {
        param.uid = /\?/.test(this.getQueryVariable("uid"))
          ? getQueryVariable("uid").split("?")[0]
          : this.getQueryVariable("uid");
      }
      if (/\/details\//.test(location.href)) {
        const regex = /\/(\d+)$/;
        const match = location.href.match(regex);
        const orderNo = match[1];
        if (orderNo) {
          param.orderNo = orderNo;
        }
      }

      axios.post("/PospalH5Pay/LoadStoreInfo", param).then(res => {
        console.log("🚀 ~ axios.post ~ res:", res)
        //获取门店信息
        if (res.status == 200) {
          if (!res.data.CommonConfig) {
            this.showLogin = true;
          }
          if (res.data.CommonConfig) {
            const CommonConfig = JSON.parse(res.data.CommonConfig);
            if (CommonConfig.visible + "" == "1") {
              this.showLogin = true;
            }
            if (CommonConfig.loginTip) {
              this.loginTip = CommonConfig.loginTip;
            }
            if (CommonConfig.showRechargeRule) {
              this.showRechargeRule = CommonConfig.showRechargeRule + "" == "1";
            }

            if (CommonConfig.balanceCombinationPayment) {
              this.balanceCombinationPayment = CommonConfig.balanceCombinationPayment
            } else {
              this.balanceCombinationPayment = 0
            }
          }
          this.CodeExtConfig = res.data.CodeExtConfig;
          this.YB_StoreName =
            res.data.CodeExtConfig && res.data.CodeExtConfig.collectionCodeName
              ? res.data.CodeExtConfig.collectionCodeName
              : res.data.StoreName;
          this.YB_StoreLogo =
            res.data.StoreLogo == "https://img.pospal.cn/storeLogo/"
              ? "https://beta2.pospal.cn/images/defaultProduct.png"
              : res.data.StoreLogo;
          this.YB_ERRORCODE = res.data.ErrorCode;
          this.YB_ORDERNO = res.data.OrderNo;
          this.YB_CollectionCodeUid = res.data.CollectionCodeUid;
          this.YB_CollectionCodeCode = res.data.CollectionCodeCode;
          this.collectionCodeUid = res.data.CollectionCodeUid;
          this.YB_CollectionCodeDesc = res.data.CollectionCodeDesc;

          axios.post("/wxapi/customeraccount/FindImmediateInfo").then(res => {
            //获取用户的当前信息，余额，可用优惠
            console.log("FindImmediateInfo 接口返回:", res);
            if (res.data && res.data.successed && res.data.result) {
              // 设置登录状态
              that.isLogin = res.data.result.isLogin || false;
              // 如果用户已登录，即使 balance 为 null/undefined，也应该显示支付方式选择
              if (res.data.result.isLogin) {
                // 处理 balance：如果为 null/undefined，设置为 0，确保支付方式选择区域能显示
                const balanceValue = res.data.result.balance;
                that.balance = (balanceValue !== null && balanceValue !== undefined)
                  ? parseFloat(balanceValue) || 0
                  : 0;

                that.categoryDiscount = res.data.result.categoryDiscount;
                if (res.data.result.categoryDiscountType != undefined) {
                  that.categoryDiscountType =
                    res.data.result.categoryDiscountType;
                }

                // 设置默认支付方式：如果启用了组合支付且输入金额大于余额，默认选中当前优先级最高的线上支付方式
                if (that.balanceCombinationPayment == 1 && that.balance > 0 && that.money > 0 && that.balance < that.money) {
                  that.payMethod = that.getDefaultOnlinePayMethod();
                  that.selectedCombinationPayment = false;
                }

                axios
                  .post("/wxapi/customeraccount/LoadChargeRules")
                  .then(_res => {
                    //获取充值规则
                    console.log("LoadChargeRules_res", _res);
                    if (_res.data.successed) {
                      this.chargeRules = _res.data.chargeRules;
                      console.log("this", this);
                    }
                  })
                  .catch(err => {
                    console.log("LoadChargeRules 接口调用失败:", err);
                  });
              } else {
                // 用户未登录，balance 保持为 null，isLogin 保持为 false
                that.isLogin = false;
                console.log("用户未登录，不显示支付方式选择");
              }
            } else {
              console.warn("FindImmediateInfo 接口返回数据格式异常:", res.data);
            }
          }).catch(err => {
            // 接口调用失败时的处理
            console.error("FindImmediateInfo 接口调用失败:", err);
            // 即使接口失败，也应该允许用户使用微信支付，所以设置 balance 为 0
            // 但这样可能会导致未登录用户也能看到支付方式，需要根据业务需求调整
            // that.balance = 0; // 如果需要接口失败时也显示支付方式，取消这行注释
          });
          if (!/isDetails|op=cancel/.test(window.location.href)) {
            let collectionCodeUid =
              window.YB_CollectionCodeUid ||
              this.collectionCodeUid ||
              getQueryVariable("collectionCodeUid");
            if (collectionCodeUid) {
              localStorage.setItem("collectionCodeUid", collectionCodeUid);
            }
          }
          // 微信支付取消的回调
          window.cancelPayment = function () {
            let collectionCodeUid =
              this.YB_CollectionCodeUid ||
              this.collectionCodeUid ||
              getQueryVariable("collectionCodeUid") ||
              localStorage.getItem("collectionCodeUid");
            localStorage.removeItem("collectionCodeUid");
            that.clearUnionPayPendingPayment();
            axios
              .post("/wxapi/PospalH5Pay/BroadcastVoice", {
                collectionCodeUid: collectionCodeUid
              })
              .then(res => {
                console.log("BroadcastVoice-res", res);
              })
              .catch(err => {
                console.log("BroadcastVoice-err", err);
              });
          };
          /**
           * 检查当前的 window.location.href 是否包含 'cancel' 字符串。
           * 如果包含，返回 true，否则返回 false。
           */
          console.log("window.location.href", window.location.href, /op=cancel/.test(window.location.href));
          if (/op=cancel/.test(window.location.href)) {
            window.cancelPayment();
            return;
          }
          // 如果是详情的参数，就去查订单，展示订单详情页面
          if (/details/.test(window.location.href)) {
            let url = window.location.href;
            let numbers = url.match(/\/details\/(\d+)/)[1];
            if (numbers && !this.OrderNo) {
              this.orderNo = numbers;
              console.log("queryDetails", this.queryDetails);
              this.loop(this.queryDetails);
            }
            return;
          }
          if (this.getQueryVariable("isDetails")) {
            this.isDetails = true;
            this.YB_ORDERNO = this.getQueryVariable("YB_ORDERNO");
            this.money = this.getQueryVariable("totalAmount");
            this.collectionCodeUid = this.getQueryVariable("collectionCodeUid");
            this.setPayresult();
            return;
          }
          if (/\/details\//.test(location.href)) {
            AlipayJSBridge.call("popWindow");
            return;
          }

          // 这个方法是个补丁，在发起支付的时候已经有orderNo了，但是这时候取消，orderNo还会存在，这样下次进来的时候就会闪退，因此加了这个逻辑，关闭app的时候删除orderNo
          document.addEventListener("visibilitychange", () => {
            if (document.visibilityState === "visible") {
              console.log(
                "浏览器的当前页签onShow时，do something",
                localStorage.getItem("orderNo")
              );
              if (
                !/\/details\//.test(location.href) &&
                localStorage.getItem("orderNo") &&
                localStorage.getItem("fromPayment")
              ) {
                //没有details且localStorage存在orderNo和fromPayment的时候说明是已经支付了并返回支付前的页面，需要关闭当前页
                // 仅在支付宝环境下调用关闭，避免在微信环境中调用导致闪退
                if (/AlipayClient/.test(window.navigator.userAgent) && window.AlipayJSBridge) {
                  console.log("进入退出程序");
                  localStorage.removeItem("orderNo");
                  localStorage.removeItem("fromPayment");
                  AlipayJSBridge.call("popWindow");
                  return;
                }
              }
            }
          });
          // 微信支付完成后的回调，根据orderNo去查订单并展示
          window.afterPayment = function (orderNo) {
            that.loop(that.queryDetails());
          };
          console.log("完成mounted", new Date().getTime());
          console.log("window-aaa", window);
        }
      });
    },
    toCharge() {
      location.href = "/m/accountv4?#/recharge";
    },
    changePaymethod: function (type) {
      console.log("选择支付方式", type);

      // 确保类型一致，转换为数字进行比较
      const balance = parseFloat(this.balance) || 0;
      // 使用实际需要支付的金额（考虑优惠券后的实付金额），如果没有则使用输入金额
      const actualAmount = this.actualPayAmount || parseFloat(this.money) || 0;

      // 如果余额充足（余额 >= 实际支付金额），不允许组合支付，直接设置用户选择的支付方式
      if (this.balance != null && actualAmount > 0 && balance >= actualAmount) {
        this.selectedCombinationPayment = false;
        this.payMethod = type;
        this.getPreferentialCost();
        return;
      }

      // 如果金额为0或未输入，直接设置用户选择的支付方式，不进行其他判断
      if (actualAmount <= 0) {
        this.selectedCombinationPayment = false;
        this.payMethod = type;
        this.getPreferentialCost();
        return;
      }

      // 如果启用了组合支付功能且实际支付金额大于余额（只有在这种情况下才允许组合支付）
      if (this.balanceCombinationPayment == 1 && this.balance != null && actualAmount > 0 && balance < actualAmount) {
        if (type === 'balance') {
          if (balance > 0 && balance < actualAmount) {
            this.selectedCombinationPayment = !this.selectedCombinationPayment;
            this.payMethod = this.isOnlinePayMethod(this.payMethod)
              ? this.payMethod
              : this.getDefaultOnlinePayMethod();
          } else {
            this.selectedCombinationPayment = false;
            this.payMethod = this.getDefaultOnlinePayMethod();
          }
        } else if (this.isOnlinePayMethod(type)) {
          this.payMethod = type;
        }
      } else {
        // 未启用组合支付功能，按原来的逻辑，直接设置用户选择的支付方式
        this.selectedCombinationPayment = false;
        this.payMethod = type;
      }

      this.getPreferentialCost();
    },
    /**
     * 根据输入的付款金额，去checkout可用的优惠，返回的第一条即为最优惠的选项，自动选中（里面的逻辑很复杂，我都盘晕了，能用就别动吧）
     */
    getPreferentialCost: debounce(function () {
      let param = {
        totalAmount: this.money,
        collectionCodeUid: this.collectionCodeUid,
        businesstype: "41",
        incCouponPrice: true,
        originalAmount: this.money,
        payMethod: "0"
      };
      if (this.payMethod == "balance") {
        param.payMethod = "2";
        if (this.categoryDiscountType == 0) {
          // 全局且余额支付，计算减后价格并传入原始价格
          param.originalAmount = this.money;
          param.totalAmount = (this.money * this.categoryDiscount) / 100;
        }
      } else {
        this.appendOnlinePayParams(param);
      }
      axios.post("/wxapi/pospalh5pay/checkout", param).then(res => {
        if (res.data.successed && res.data.result) {
          const that = this;
          // 获取当前输入的金额
          const currentAmount = parseFloat(this.money) || 0;

          if (
            res.data.result.useableCoupons &&
            res.data.result.useableCoupons[0].couponCodes
          ) {
            const coupon = res.data.result.useableCoupons[0];
            // 验证优惠券是否可用：检查金额是否满足使用条件
            // 检查优惠券的最低使用金额（可能在不同字段中：minAmount, minUseAmount, minUsePrice等）
            const minAmount = coupon.minAmount || coupon.minUseAmount || coupon.minUsePrice || 0;

            // 如果设置了最低使用金额，且当前金额小于最低使用金额，则清除优惠券信息
            if (minAmount > 0 && currentAmount < minAmount) {
              // 金额不满足优惠券使用条件，清除优惠券信息
              this.preferentialInfo = null;
            that.DiscountAmount = null;
            } else {
              // 金额满足条件，设置优惠券信息
              this.preferentialInfo = coupon;
              that.DiscountAmount = null;
              let name = coupon.discountName;
              coupon.discountAnalyses.forEach(a => {
              if (a.ActivityName == name) {
                that.DiscountAmount = a.DiscountAmount;
              }
            });
            }
          } else {
            // 没有可用优惠券，清除优惠券信息
            this.preferentialInfo = null;
            that.DiscountAmount = null;
          }
          if (this.preferentialInfo) {
            this.paidInAmount = this.preferentialInfo.discountPrice;
          } else {
            this.paidInAmount = res.data.result.totalAmount;
          }
          // 移除自动切换到余额支付的逻辑，允许用户自由选择支付方式
          // 即使余额充足，用户也可以选择使用微信支付
          this.discountAnalyses = res.data.result.discountAnalyses[0];
          if (
            !res.data.result.useableCoupons &&
            res.data.result.discountAnalyses
          ) {
            const i = res.data.result.discountAnalyses.findIndex(
              a => a.ActivityName == "会员折扣"
            );
            if (i != -1) {
              that.foldUp = true;
            } else {
              that.foldUp = false;
            }
          }
          if (res.data.result.discountAnalyses) {
            if (!this.autoPreferential) {
              const i = res.data.result.discountAnalyses.findIndex(
                a => a.ActivityName == "会员折扣"
              );
              if (i != -1) {
                that.foldUp = true;
              } else {
                that.foldUp = false;
              }
            } else {
              if (res.data.result.useableCoupons && res.data.result.useableCoupons[0] && res.data.result.useableCoupons[0].discountAnalyses) {
                const i = res.data.result.useableCoupons[0].discountAnalyses.findIndex(
                  a => a.ActivityName == "会员折扣"
                );
                console.log("i", i);
                if (i != -1) {
                  that.foldUp = true;
                } else {
                  that.foldUp = false;
                }
              }
            }
          }
          if (
            res.data.result.useableCoupons &&
            res.data.result.useableCoupons[0] &&
            res.data.result.useableCoupons[0].discountAnalyses &&
            res.data.result.useableCoupons[0].discountAnalyses.findIndex(
              a => a.ActivityName == "会员折扣"
            ) == -1 &&
            res.data.result.useableCoupons[0].discountAnalyses.length > 0
          ) {
            this.totalAmount = res.data.result.useableCoupons[0].discountPrice;
          } else {
            this.totalAmount = res.data.result.totalAmount;
          }
        }
      });
    }, 500),
    handleClickOutside() {
      this.showKeyBorad = false;
    },
    loop(func, num = 0) {
      let time = 1000;
      if (num < 2 && !this.orderInfo) {
        setTimeout(() => {
          num++;
          func();
        }, time);
      }
    },
    debounce(func, delay) {
      let timeoutId;
      return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          func.apply(context, args);
        }, delay);
      };
    },
    toCenter() {
      window.location.replace(
        `/m/accountv4?returnurl=${encodeURI(
          window.location.pathname + window.location.search
        )}`
      );
      return;
    },
    startPress() {
      this.pressStartTime = new Date().getTime();
      this.isPressing = true;
      setTimeout(() => {
        if (this.isPressing) {
          this.content = [];
          this.money = "";
          this.cursorIndex = 0;
        }
      }, 500);
    },
    endPress() {
      this.pressEndTime = new Date().getTime();
      this.isPressing = false;
      if (this.pressEndTime - this.pressStartTime < 500) {
        this.keyTap("<");
      }
    },
    handlePay() {
      if (this.money && this.money != "0.") {
        this.showKeyBorad = false;
      }
    },
    openVirtualKeyboard() {
      this.showKeyBorad = true;
    },
    getStrPosition(strIndex) {
      this.cursorIndex = strIndex;
    },
    keyTap(keys) {
      if (this.content.length >= 8 && keys != "<") {
        return;
      }
      let content = this.content.join(""); // 转为字符串
      const strLen = this.content.length;
      switch (keys) {
        case ".":
          if (content.indexOf(".") === -1) {
            // 已有一个点的情况下
            content.length < 1 ? (content = "0.") : (content += ".");
            this.cursorIndex = content.length;
          }
          break;
        case "<":
          if (this.cursorIndex > 0 && this.cursorIndex !== strLen) {
            // 从插入光标开始删除元素
            this.content.splice(this.cursorIndex - 1, 1);
            content = this.content.join("");
          } else {
            content = content.substr(0, content.length - 1);
          }
          if (!strLen) {
            // 插入光标位置重置
            this.cursorIndex = "0";
          }
          // 删除点 组件中可以用Observer监听删除点和删除0的情况
          if (content[0] === "0" && content[1] !== ".") {
            content = content.substr(1, content.length - 1);
          }
          if (content[0] === ".") {
            content = "0" + content;
          }
          if (this.cursorIndex == 1 || content.length == 0) {
            this.cursorIndex = content.length;
          } else {
            this.cursorIndex = this.cursorIndex - 1;
          }
          break;
        default:
          let spotIndex = content.indexOf("."); //小数点的位置
          if (content[0] === "0" && content[1] !== ".") {
            content = content.substr(1, content.length - 1);
          }
          if (spotIndex === -1 || strLen - spotIndex !== 3) {
            //小数点后只保留两位
            content += keys;
            this.cursorIndex = content.length;
          }
          break;
      }
      this.content = content.split("");
      this.money = content;
      this.paidInAmount = content;
      this.getPreferentialCost();
    },
    getQueryVariable(variable) {
      let query = window.location.search.substring(1);
      let vars = query.split("&");
      for (let i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    },
    getMessage(code) {
      switch (code * 1) {
        case 100:
          return "店铺异常";
        case 201:
          return "微信支付配置错误";
        case 202:
          return "支付宝支付配置错误";
        case 300:
          return "收款码不存在";
        case 301:
          return "收款码未启用";

        default:
          return "";
      }
    },
    handlePayClick: debounce(function () {
      if (this.money && this.money != "" && this.money != 0) {
        this.setPayresult();
      }
    }, 500),
    async setPayresult() {
      if (this.payFlag) return;
      this.payFlag = true;
      let param = {
        totalAmount: this.money,
        collectionCodeUid:
          this.collectionCodeUid || localStorage.getItem("collectionCodeUid"),
        businesstype: "41"
      };

      if (!this.collectionCodeUid && getQueryVariable("uid")) {
        this.collectionCodeUid = getQueryVariable("uid");
        param.collectionCodeUid = getQueryVariable("uid");
        // 存储collectionCodeUid供后续使用
        localStorage.setItem("collectionCodeUid", param.collectionCodeUid);
      }

      if (!param.collectionCodeUid) {
        alert("支付参数缺失，请重新扫码");
        this.payFlag = false;
        return;
      }

      // 应该是如果余额>0且不够支付，就默认选中余额+线上支付
      // 使用实际需要支付的金额（考虑优惠券后的实付金额）来判断
      if (this.balanceCombinationPayment == 1 && this.selectedCombinationPayment ) {
        const actualAmount = this.actualPayAmount;
        if (this.balance > 0 && this.balance < actualAmount) {
          param.combinedWithCustomerBalance = true
        }
      }

      if (this.payMethod == "balance" && !param.combinedWithCustomerBalance) {
        param.payMethod = "2";
        if (this.categoryDiscountType == 0) {
          // 全局且余额支付，计算减后价格并传入原始价格
          param.originalAmount = this.money;
          param.totalAmount = (this.money * this.categoryDiscount) / 100;
        }
      } else if (!param.combinedWithCustomerBalance) {
        // 明确设置线上支付方式，避免后端误判
        this.appendOnlinePayParams(param);
      }
      if (this.preferentialInfo && this.autoPreferential) {
        // 如果是使用自动优惠那就用新参数覆盖之前的旧参数，并且接口也走place，否则就用旧参数，走payresult接口
        if (this.payMethod == "balance" && !param.combinedWithCustomerBalance) {
          param.payMethod = "2";
        } else {
          this.appendOnlinePayParams(param);
        }
        param.originalAmount = this.money;
        if (this.categoryDiscountType == 0) {
          param.totalAmount = Math.max(
            0,
            (this.preferentialInfo && this.preferentialInfo.discountPrice ? this.preferentialInfo.discountPrice : 0) * this.categoryDiscount / 100
          );
        } else {
          param.totalAmount = Math.max(0, this.preferentialInfo && this.preferentialInfo.discountPrice ? this.preferentialInfo.discountPrice : 0);
        }
        param.couponCodes =
          this.CodeExtConfig.supportCoupon === false
            ? []
            : (this.preferentialInfo && this.preferentialInfo.couponCodes && this.preferentialInfo.couponCodes.length > 0)
            ? [this.preferentialInfo.couponCodes[0]]
            : [];
      }

      // 处理组合支付的情况
      if (param.combinedWithCustomerBalance) {
        this.appendOnlinePayParams(param);
        param.originalAmount = this.money;
        // 组合支付时不需要优惠券，使用原始金额
        param.totalAmount = this.money;
        param.couponCodes =
          this.CodeExtConfig.supportCoupon === false
            ? []
            : (this.preferentialInfo && this.preferentialInfo.couponCodes && this.preferentialInfo.couponCodes.length > 0)
            ? [this.preferentialInfo.couponCodes[0]]
            : [];
      }

      if (this.remark) {
        // if (param.collectioncodeticket) {
        //   param.collectioncodeticket.remark = this.remark;
        // } else {
        //   // 兜底处理，比如初始化这个对象
        //   param.collectioncodeticket = { remark: this.remark };
        // }
        param.remark = this.remark;
      }


      axios
        .post(
          (this.preferentialInfo && this.autoPreferential) || param.combinedWithCustomerBalance
            ? "/wxapi/pospalh5pay/place"
            : "/wxapi/pospalh5pay/payresult",
          param
        )
        .then(res => {
          this.payFlag = false;
          console.log("res", res, JSON.stringify(res));
          if (res.data.successed) {
            // 请求成功时设置支付标记
            localStorage.setItem("fromPayment", "true");
            localStorage.setItem("orderNo", res.data.OrderNo);
            localStorage.setItem("collectionCodeUid", this.collectionCodeUid);
            if (this.payMethod == "unionpay") {
              const pendingPayToken = Date.now().toString() + Math.random().toString(36).substr(2);
              localStorage.setItem("pendingPayMethod", "unionpay");
              localStorage.setItem("pendingPayTime", Date.now().toString());
              this.setUnionPayPendingToken(pendingPayToken);
              this.unionPayPageHidden = true;
              this.startUnionPayReturnPolling();
            } else {
              localStorage.removeItem("pendingPayMethod");
              localStorage.removeItem("pendingPayTime");
              this.clearUnionPayPendingToken();
              this.unionPayPageHidden = false;
              this.stopUnionPayReturnPolling();
            }

            console.log("1");
            this.orderFlag = true;
            this.orderNo = res.data.OrderNo;
            console.log("2", this, res);
            if (res.data.Message == "支付成功" && !res.data.Script) {
              setTimeout(() => {
                this.queryDetails();
              }, 500);
              return;
            }
            let script = res.data.Script;
            if (
              /AlipayClient/.test(window.navigator.userAgent) &&
              this.payMethod != "balance"
            ) {
              //支付宝条件下支付的特殊处理，但是现在用银豹付，统一支付环境了，貌似没用了
              localStorage.setItem("orderNo", res.data.OrderNo);
              localStorage.setItem("collectionCodeUid", this.collectionCodeUid);
              script = script.replace(
                /tradeNO/g,
                `displayPayResult:false, tradeNO`
              );
            } else {
              console.log("开始替换");
              console.log("原脚本-", script);
              console.log(
                "测试捕获要改的脚本-",
                /modal\.hideIndicator\(\)\;\}\}/.test(script)
              );
              if (this.payMethod != "balance") {
                // 替换脚本，触发我们的方法（现在貌似也用不到了，不用管了）
                script = script.replace(
                  /modal\.hideIndicator\(\)\;\}\}/g,
                  `if (window.cancelPayment) {window.cancelPayment();};modal.hideIndicator();}}`
                );
              }
            }
            if (this.payMethod == "balance") {
              setTimeout(() => {
                this.queryDetails();
              }, 500);
            }
            if (script) {
              this.executePayScript(script);
            }
          } else {
            alert(res.data.Message ? res.data.Message : res.data.message);
          }
        })
        .catch(err => {
          this.payFlag = false;
          console.log("err", err, JSON.stringify(err));
        });
    },
    queryDetails() {
      axios
        .post("/wxapi/pospalh5pay/Details", {
          orderNo: this.orderNo,
          incCustomer: true
        })
        .then(res => {
          if (res.data.successed) {
            console.log(JSON.stringify(res.data.result));
            this.orderInfo = res.data.result;
            localStorage.removeItem("fromPayment");
            localStorage.removeItem("pendingPayMethod");
            localStorage.removeItem("pendingPayTime");
            this.clearUnionPayPendingToken();
            this.stopUnionPayReturnPolling();
          }
        });
    }
  }
};
</script>

<style>
@import url(./styles/index.css);

.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.loading-spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loading-text {
  color: #fff;
  font-size: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue